<app-image-box-link (onClickEmit)="emit_onClick()"
    (loaded)="emit_onLoaded()"
    [border]="true"
    [matTooltipPosition]="tooltipPosition"
    [matTooltip]="tooltip" 
    [noClick]="noClick"
    [url]="url" 
 />
<ng-content />
